import { VerticalModuleProvider } from '@lipaflow/shared'
import { B2BApp } from '@lipaflow/b2b-core'
import { rentalOperatorModule } from '@lipaflow/rental/operator'

/**
 * Property Portal — a Tier 3 composition root.
 *
 * It owns one decision: which vertical this deployment serves. Everything
 * else is `@lipaflow/b2b-core`, and every page only this vertical understands
 * comes from its Tier 2 package (ADR-0004).
 */
export default function App() {
  return (
    <VerticalModuleProvider module={rentalOperatorModule}>
      <B2BApp />
    </VerticalModuleProvider>
  )
}
